export default __webpack_public_path__ + "static/media/expart-intro-background.7333e18d.png";